import { Link, Navigate } from "react-router-dom";
import { SignInForm } from "@/components/auth/sign-in-form";
import { useAuth } from "@/hooks/useAuth";

export function SignInPage() {
  const { isAuthenticated, initialized } = useAuth();

  if (initialized && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-foreground">ceo-cmd</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Sign in to your command centre
          </p>
          {import.meta.env.DEV && (
            <p className="mt-2 text-xs text-brand">
              Dev mode: opening app routes auto-signs in as Dev User
              (dev@local.test).
            </p>
          )}
        </div>

        <div className="rounded-lg border border-border bg-card p-6">
          <SignInForm />
        </div>

        <p className="mt-4 text-center text-sm text-muted-foreground">
          Don&apos;t have an account?{" "}
          <Link
            to="/signup"
            className="font-medium text-brand hover:underline"
          >
            Sign up
          </Link>
        </p>
      </div>
    </main>
  );
}
